export const TypesFieldEnum = Object.freeze({
  SELECTION: 'selection',
  MULTISELECTION: 'multiselection',
  CHECKBOX: 'checkbox',
  MULTICHECKBOX: 'multicheckbox',

  DATE: 'date',
  DATE_HEURE: 'date-heure',
  BIRTH_DATE: 'birth_date',

  CHAR: 'char',
  ALPHANUMERIQUE: 'alphanumerique',

  ENTIER: 'entier',
  INTEGER: 'integer',
  NUMERIC: 'numeric',
  NUMERIQUE: 'numerique',
  NUMBER: 'number',
  CURRENCY: 'currency',
  PERCENTAGE: 'percentage',

  BOOLEAN: 'boolean',

  SELECTIONCOUNTRY: 'selectioncountry',
  TEXT: 'text',
  EMAIL: 'email',
  PHONE: 'phone',
  TEL: 'tel',
  SSN: 'ssn',

  ADDITIONAL_ADDRESS: 'additional_address',
  CALCULATED: 'calculated',
});
